import { memo, forwardRef, FC } from "react";
import Text from "../Text";
import { LinkStyled } from "./Link.styled";
import { LinkProps } from "./types";
import { WithStyle } from "utils/WithStyle";

const Component: FC<LinkProps> = memo(
    forwardRef(({ href, variant, children, ...props }, ref) => {
        return (
            <LinkStyled ref={ref} to={href} {...props}>
                <Text variant={variant}>{children}</Text>
            </LinkStyled>
        );
    })
);

export const Link: FC<LinkProps> & WithStyle = Object.assign(Component, {
    Style: LinkStyled,
});
